/*
@PRODUCT_FEATURE: H 1.2, H 1.3.0, H 1.4
*/
/* eslint-disable react/display-name */
import React, { useEffect } from 'react';
import Loader from '@24i/nxg-sdk-gluons/src/components/ui/Loader';
import { BlockModalTypes } from '@24i/nxg-sdk-smartott/src/components/BlockedModal/types';
import useBlockedModal from '@24i/nxg-sdk-smartott/src/components/BlockedModal/hooks/useBlockedModal';
import { useAssetPinControl } from '@24i/nxg-sdk-pin-protection/src/hooks/useAssetPinControl';
import {
    isTelegramAVersion,
    isTelegramKVersion,
    isWebView,
    getTelegramWebApp,
} from '@24i/nxg-sdk-higgs/src/utils';

import View from './View';
import {
    defaultRenderEpisodePicker,
    defaultRenderPackshotGrid,
    defaultRenderDetailsTab,
} from './components/BottomPart';
import { useViewModel } from './viewModel';
import getDetailsScreenStyles from './styles';
// use when SSR is re-implemented
// import * as prerenderFunctions from '../../pages/details/[type]/[id]';
import DetailsScreenContent from './components/DetailsScreenContent';
import EpisodePicker from './components/EpisodePicker';
import { DetailsScreenProps } from './types';
import { WithWebHeaderProps } from '../../navigation/components/withWebHeader/types';

const Main = (props: DetailsScreenProps) => {
    const viewModelProps = useViewModel(props);
    const { openBlockedModal } = useBlockedModal();
    const { hasAgeBlocker, hasAdultBlocker, triggerPinControl } = useAssetPinControl({
        active: false,
        ...props,
        ...viewModelProps,
    });
    useEffect(() => {
        if (hasAgeBlocker || hasAdultBlocker) {
            (async () => {
                const pinValidated = await triggerPinControl();
                if (!pinValidated) {
                    openBlockedModal(BlockModalTypes.MVPD_PROTECTION_LEVEL_FULL, undefined, {
                        onModalClose: () => {
                            viewModelProps.onCloseErrorModal?.();
                        },
                    });
                }
            })();
        }
    }, [hasAgeBlocker, hasAdultBlocker]);

    if (hasAgeBlocker || hasAdultBlocker) {
        return <Loader />;
    }

    const isTelegramK = isTelegramKVersion();
    const TelegramWebApp = getTelegramWebApp();
    const isFullscreen = TelegramWebApp?.isFullscreen;

    // We need different header behavior based on combination of Telegram K and fullscreen mode
    const webHeaderProps: WithWebHeaderProps = {
        fullWidth: true,
        hasMargin: false,
        // CRITICAL: Never force disable for Telegram K, as that would prevent back button setup
        // Instead, control visibility via isTelegramNonFullscreen flag
        forceDisable: !isWebView() && !isTelegramKVersion() && !isTelegramAVersion(),
        // Always use the native back button mechanism for Telegram K
        backButtonTitle: viewModelProps.asset?.title ?? '',
        // For Telegram K in fullscreen mode, show sticky header
        // For Telegram K in non-fullscreen mode, don't show sticky header but still init back button
        variant: 'sticky',
        // Add a custom flag to identify Telegram K non-fullscreen case
        isTelegramNonFullscreen: isTelegramK && !isFullscreen,
    };

    return <View {...viewModelProps} {...webHeaderProps} />;
};

export default {
    Main,
    View,
    useViewModel,
    getDefaultStyles: getDetailsScreenStyles,
    // use when SSR is re-implemented
    // page: {
    //    details: {
    //        '[type]': {
    //            '[id]': prerenderFunctions,
    //        },
    //    },
    // },
    // components
    DetailsScreenContent,
    EpisodePicker,
    // default render functions
    defaultRenderEpisodePicker,
    defaultRenderPackshotGrid,
    defaultRenderDetailsTab,
};
